@if (
  {
    selectedDepartment: selectedDepartment(),
    departmentList: departmentListSorted(),
  };
  as departments
) {
  <mat-form-field appearance="fill">
    <mat-select
      #matSelect
      [ngModel]="departments.selectedDepartment?.id"
      [hideSingleSelectionIndicator]="true"
      panelClass="department-dropdown-select"
      (selectionChange)="selectDepartment($event, matSelect); matSelect.close()"
      (openedChange)="onPanelOpenedChange($event)"
    >
      <div class="department-search-wrapper">
        <mat-icon class="search-icon material-icons-outlined">search</mat-icon>
        <input
          #searchInput
          (keyup)="$event.stopPropagation(); onSearch($event)"
          (keydown)="$event.stopPropagation()"
          (keydown.space)="$event.preventDefault(); $event.stopPropagation()"
          [placeholder]="'search' | translate"
          class="mat-dropdown-select-input department-search-input"
        />
      </div>
      <mat-select-trigger>
        <img
          width="36"
          height="36"
          class="department-trigger-img"
          [src]="
            departments.selectedDepartment?.id === allDepsToken
              ? allDepsIconPath
              : (departments.selectedDepartment?.logo | appendDomain) ||
                departmentPlaceHolderIconPath
          "
          alt="department logo"
        />
        <span class="vessel-name">
          {{ departments.selectedDepartment?.name || 'allDepartments' | translate }}
        </span>
      </mat-select-trigger>
      @for (option of filteredDepartments; track option.id) {
        <mat-option
          [value]="option.id"
          [class.selected-department-option]="option.id === departments.selectedDepartment?.id"
        >
          <img
            width="50"
            height="50"
            class="rounded-border"
            [src]="(option.logo | appendDomain) || departmentPlaceHolderIconPath"
            alt="vessel picture"
          />
          <div class="department-option-container">
            <span class="left-details-col">
              <h3>{{ option.name }}</h3>
              <span class="vessel-details">
                <div class="vessel-headings-row">
                  <span>LOA</span>
                  <span>DW</span>
                  <span>GRP</span>
                </div>
                <div class="vessel-info-row">
                  <span>-</span>
                  <span>-</span>
                  <span>-</span>
                </div>
              </span>
            </span>
          </div>
        </mat-option>
      }
      @if (departments.departmentList && departments.departmentList.length > 1) {
        <mat-option
          [value]="allDepsToken"
          class="all-departments-opt"
          [class.selected-department-option]="departments.selectedDepartment?.id === allDepsToken"
        >
          <img
            width="50"
            height="50"
            class="rounded-border"
            [src]="allDepsIconPath"
            alt="vessel picture"
          />
          <div class="department-option-container">
            <span class="left-details-col">
              <h3>{{ 'allDepartments' | translate }}</h3>
            </span>
          </div>
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}
